module.exports = __webpack_public_path__ + "ba16cc3b9fccadfae8b5a4b47a2d719c.svg";